import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations synchronously to ensure they're available immediately
import enTranslations from './locales/en/common.json';
import ltTranslations from './locales/lt/common.json';

// Initialize i18n with translations
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enTranslations
      },
      lt: {
        common: ltTranslations
      }
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    debug: import.meta.env.DEV,
    
    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    react: {
      useSuspense: false,
    },
    
    // Enable returning objects from translations
    returnObjects: true,
  });

export default i18n;
